import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import InsuranceImg from "../../images/Insurance.jpg";

const InsuranceHero = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100vh",
        backgroundImage: `url(${InsuranceImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Soft overlay so text is readable on bright background */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: "rgba(255,255,255,0.15)",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            bgcolor: "rgba(22, 45, 180, 0.82)",
            px: { xs: 3, md: 6 },
            py: { xs: 4, md: 6 },
            width: "100%",
            maxWidth: 1180,
            mx: "auto",
          }}
        >
          <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
            {/* Left: Title */}
            <Grid item xs={12} md={5}>
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                  fontSize: { xs: 35, sm: 45, md: 58 },
                  lineHeight: { xs: 1.02, md: 1.0 },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Our Insurance
                <br />
                Solutions
              </Typography>
            </Grid>

            {/* Middle: Divider */}
            <Grid
              item
              xs={12}
              md={1}
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: "2px",
                  height: 190,
                  bgcolor: "rgba(255,255,255,0.7)",
                }}
              />
            </Grid>

            {/* Right: Description */}
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.95)",
                  fontSize: { xs: 14, md: 16 },
                  lineHeight: 1.8,
                  fontWeight: 600,
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                We specialize in providing high tech talent to insurance
                companies. Jobs in financial sector are most sought after among
                new college graduates and experienced professionals alike. But
                we know, it isn’t a task for everyone. AlphaForce will find the
                right candidates for you, to ensure your business flourishes
                like never before. Our recruitment services will find you the
                most optimized help. Our project services teams are also geared
                to the insurance industry as well, from application development
                projects, to data analytics projects.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

const Insurance = () => {
  return (
    <Box>
      <InsuranceHero />
      {/* Add the rest of the Insurance page sections below */}
    </Box>
  );
};

export default Insurance;
